// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Component, OnInit, Input, ViewChild, SimpleChanges, OnChanges, AfterViewInit } from '@angular/core';
import { RoleDetail, IAMUser, RoleUserScope } from '@app/core';
import { Store } from '@ngrx/store';
import { DataTableAjaxComponent } from '@app/shared/data-table-ajax/data-table-ajax.component';
import { State } from '@app/access-management/state';

@Component({
  selector: 'app-user-details-row',
  templateUrl: './user-details-row.component.html',
  styleUrls: ['./user-details-row.component.scss']
})
export class UserDetailsRowComponent implements OnInit, OnChanges, AfterViewInit {
  @ViewChild('dataTableAjax') dataTableAjax!: DataTableAjaxComponent;

  columns: any[] = [];

  roleuserscopes?: Array<RoleUserScope>;
  username?: string;

  @Input() roleRow?: RoleDetail = undefined;
  @Input() userName?: IAMUser;

  role: any;

  constructor(private store: Store<State>) {}

  ngOnInit() {
    this.role = this.roleRow && this.roleRow.role;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['roleDetail'] && changes['roleDetail'].currentValue) {
      this.role = this.roleRow && this.roleRow.role;
      if (this.dataTableAjax) {
        this.dataTableAjax.refreshTable();
      }
    }
    if (changes['userName'] && changes['userName'].currentValue) {
      if (this.dataTableAjax) {
        this.dataTableAjax.refreshTable();
      }
    }
  }

  ngAfterViewInit() {
    this.columns = [
      {
        name: 'Constraints',
        prop: 'object_name',
        headerClass: 'ml-8',
        flexGrow: 2
      },
      {
        name: 'Scope',
        prop: 'object_type_name',
        flexGrow: 1
      },
      {
        name: 'Level',
        prop: 'level',
        flexGrow: 1
      }
    ];
  }

  trackColumns(idx: number) {
    return idx;
  }
}



// WEBPACK FOOTER //
// ./src/app/access-management/users/user-details/user-details-row/user-details-row.component.ts